import { apiFetch } from '@/shared/api/client'

export type ActivateDeviceRequest = {
  activation_code: string
  device_uid: string
  os?: string
}

/**
 * Satu endpoint untuk kedua device_type — server coba jalur tablet dulu, fallback
 * ke delman bila kode bukan untuk tablet (lihat superoti-warehouse-server
 * internal/domain/auth/service.go Service.ActivateDevice). Field opsional terisi
 * sesuai device_type hasil aktivasi.
 */
export type ActivateDeviceResponse = {
  device_id: string
  device_uid: string
  device_name: string
  device_type: 'warehouse_tablet' | 'warehouse_delman_mobile'
  brand_id: string
  warehouse_id?: string
  warehouse_code?: string
  warehouse_name?: string
  delman_user_id?: string
  delman_name?: string
}

export async function activateDevice(req: ActivateDeviceRequest): Promise<ActivateDeviceResponse> {
  return apiFetch<ActivateDeviceResponse>('/auth/activate', {
    method: 'POST',
    body: JSON.stringify(req),
  })
}
